import {
  ROLELIST_FETCHITEMS_LOAD,
  ROLELIST_FETCHITEMS_SUCCEED,
  ROLELIST_FETCHITEMS_FAIL,
  ROLELIST_CHANGETABLE_CHANGE,
  ROLELIST_SEARCHTABLE_EDIT,
  ROLELIST_SEARCHTABLE_SEARCH,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case ROLELIST_FETCHITEMS_LOAD:
      return { ...state, isFetchItemsLoading: true, fetchItemsError: null }
    case ROLELIST_FETCHITEMS_SUCCEED:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: action.items,
        pagination: { ...state.pagination, total: action.total },
      }
    case ROLELIST_FETCHITEMS_FAIL:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: null,
        fetchItemsError: action.fetchItemsError,
      }
    case ROLELIST_CHANGETABLE_CHANGE: {
      return {
        ...state,
        pagination: action.pagination,
        filters: action.filters,
        sorter: action.sorter,
      }
    }
    case ROLELIST_SEARCHTABLE_EDIT:
      return {
        ...state,
        search: action.search,
      }
    case ROLELIST_SEARCHTABLE_SEARCH:
      return {
        ...state,
        isSearching: action.isSearching,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/roleList.js